/**
 * 与 webview preload 注入的 `electronBridge` 对齐：载荷为 `{ type, data? }`。
 */

export type ElectronBridge = {
  sendToElectron?: (msg: { type: string; data?: unknown }) => void;
  onElectronMessage?: (cb: (type: string, data: unknown) => void) => () => void;
};

export function getElectronBridge(): ElectronBridge | null {
  if (typeof window === "undefined") return null;
  return (
    (window as unknown as { electronBridge?: ElectronBridge }).electronBridge ??
    null
  );
}

/** 主应用 webview（有 electronBridge）；登录窗等仅 electronAPI 的窗口返回 false */
export function isElectronWebviewRuntime(): boolean {
  return Boolean(getElectronBridge()?.sendToElectron);
}

export function sendToElectron(type: string, data?: unknown): void {
  const bridge = getElectronBridge();
  if (!bridge?.sendToElectron) return;
  try {
    bridge.sendToElectron(data === undefined ? { type } : { type, data });
  } catch {
    // ignore
  }
}
